import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../../offer/list/constants/offer_list";

export const InvestmentOfferListPagination = () => {
    const location = useLocation();
    const {isMobile} = useUserDevice();

    const count = useSelector((state: IRPStore) => state.investmentOffer.list.offers.count);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const maxPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;

    return (
        <Pagination
            getPageLink={getPageLink}
            pageCount={maxPage}
            currentPage={currentPage}
            size={isMobile ? PaginationSize.MD : PaginationSize.LG}
            siblingsCount={isMobile ? 0 : 1}
        />
    );
};
import React from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";

import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {OFFER_LIST_PAGE_SIZE} from "../../../offer/list/constants/offer_list";

export const InvestmentOfferListPagination = () => {
    const location = useLocation();
    const {isMobile} = useUserDevice();

    const count = useSelector((state: IRPStore) => state.investmentOffer.list.offers.count);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query) + location.hash;
    };

    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const maxPage = count ? Math.ceil(count / OFFER_LIST_PAGE_SIZE) : 1;

    return (
        <Pagination
            getPageLink={getPageLink}
            pageCount={maxPage}
            currentPage={currentPage}
            size={isMobile ? PaginationSize.MD : PaginationSize.LG}
            siblingsCount={isMobile ? 0 : 1}
        />
    );
};
